import React from 'react';
import Cost from './Cost';
import Column from '../../../../shared/components/atoms/Column';
import { OverallConnectionType } from '../../../../Quotes/types/connectionType';
import { ProductType } from '../../../../Quotes/types/productTypes';
import { PortCost } from 'Quotes/types/pricedQuote';

export function BEndPortCosts(props: {
  connectionType: OverallConnectionType;
  productType: ProductType;
  bEndPortCost: PortCost | null;
}) {
  return (
    <>
      {((props.connectionType === 'Ethernet' && props.productType !== ProductType.DIA) || props.productType === ProductType.OpticalP2P) && (
        <div className="row no-gutters mt-1">
          <Column defaultWidth={2} offsetDefaultWidth={2}>
            <span>Port</span>
          </Column>
          <Cost label="Install" cost={props.bEndPortCost?.install ?? 0} className="port-b-install" />
          <Cost label="Annual" cost={props.bEndPortCost?.annual ?? 0} className="port-b-annual" />
        </div>
      )}
    </>
  );
}
